import Head from 'next/head'
import { useTranslation } from 'hooks/useTranslation'
import { RawBenefits } from 'features/RawBenefits'

const RawBenefitsPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <title>{t('raw-benefits:page-title')}</title>
        <meta name="title" content={t('raw-benefits:page-title')} />
        <meta name="description" content={t('raw-benefits:meta-description')} />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://wefeedraw.com/raw-benefits" />
      </Head>
      <RawBenefits />
    </>
  )
}

export default RawBenefitsPage
